import React, {useCallback, useEffect, useState} from "react"
import Box, {Direction} from "./Box";
import Title from "./Title";

import styles from "../css/RadioButtonInput.module.css"
import classNames from "classnames";

interface Props {
    title: string,
    defaultValue?: string,
    onOptionChange?: (value: string) => void,
    options: Array<{ value: string, label: string, disabled?: boolean, onClick?: () => void }>
}

export default (props: Props) => {

    // Props

    const {
        title, onOptionChange, defaultValue, options
    } = props;

    // State

    const [selectedValue, setSelectValue] = useState<string | undefined>(defaultValue || options[0].value);

    // Callbacks

    const handleOptionChange = useCallback(
        e => {
            setSelectValue(e.target.value);
            onOptionChange && onOptionChange(e.target.value)
        },
        [onOptionChange],
    );

    // Effects

    useEffect(()=> {
        setSelectValue(defaultValue);
    }, [defaultValue]);

    return (
        <Box center direction={Direction.Column}>

            <Title xs center={false} title={title}/>
            <Box topMargin={6} bottomMargin={6} line className={classNames(styles.line)}/>

            {
                options.map(({value, label, disabled = false, onClick}, index: number) => {
                    return (
                        <Box key={`${index}_${value}`} topMargin={8}>
                            <label style={{ position: 'relative' }} onClick={disabled ? onClick : undefined}>
                                {
                                    disabled && onClick &&
                                    <div className={styles.disabledOnClick} onClick={onClick}/>
                                }
                                <input
                                    type="radio"
                                    name={label}
                                    disabled={disabled}
                                    value={value}
                                    onClick={onClick}
                                    checked={value === selectedValue}
                                    onChange={handleOptionChange}
                                />
                                <span className={classNames(styles.label, {
                                    [styles.disabled]: disabled,
                                })}>{label}</span>
                            </label>
                        </Box>)
                })
            }

        </Box>
    );
}

